import {filter, from, mergeMap, Observable, withLatestFrom} from "rxjs";
import { Action } from "@reduxjs/toolkit";
import {setFiles, resetUpload, retry} from "../slices";
import {selectFailedFiles, selectFiles, selectStoppedFiles} from "../selectors";

export const retryEpic = (
  action$: Observable<Action>,
  state$: Observable<any>
) => {
  return action$.pipe(
    filter(retry.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {

      const files = selectFiles(state);
      const failed = selectFailedFiles(state)
        .map(files => files.fileName);
      const stopped = selectStoppedFiles(state)
        .map(files => files.fileName);
      const filesToRetry = files
        .filter(file => failed.includes(file.name) || stopped.includes(file.name));

      console.log("files to retry", filesToRetry)

      return from([setFiles(filesToRetry), resetUpload()]);
    })
  );
};
